import HomepageFilterModal from './HomepageFilterModal.vue';

export default HomepageFilterModal;
